import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';

import {
  LegacyAllowanceProposalWorkflowTableData,
  LegacyBenefitProposalWorkflowTableData,
  LegacySalaryProposalWorkflowTableData,
} from '~/data/proposals';

type PropsType = {
  columns: GridColDef[];
  rows:
    | LegacyAllowanceProposalWorkflowTableData[]
    | LegacyBenefitProposalWorkflowTableData[]
    | LegacySalaryProposalWorkflowTableData[];
};
export const ProposalsWorkflowTableLayout = (props: PropsType) => {
  const { columns, rows } = props;
  return (
    <DataGridPro
      sx={{
        ml: '48px',
        '& .MuiDataGrid-columnHeaders': {
          height: 0,
        },
      }}
      autoHeight={true}
      rows={rows}
      columns={columns}
      getRowId={(row) => row.fEmplSubEnteredTime}
      hideFooterPagination
      hideFooterSelectedRowCount
      hideFooter
    />
  );
};
